import React, { useState, useEffect } from "react";
import { Spin, Table, Tag, Switch, Input, Tooltip } from "antd";
import { getPermissions, PermissionRole } from "../../../API/api";
import { SearchOutlined, SyncOutlined } from "@ant-design/icons";
import { filtering, SearchBar } from "../../AdminManageRole/AdminManageRole";
import TitleValue from "../../cmOverview/tabs/seeker/TitleValue";
import VizHeader from "../../VizHeader/VizHeader";
import styles from "./Permission.module.css";

export default function PermissionTable() {
  const [permissions, setPermissions] = React.useState([]);
  const [value, setValue] = useState("");
  const [isLoading, setLoading] = React.useState(false);
  const [spinning, setSpinning] = React.useState(false);

  const fetchPermissions = () => {
    setLoading(true);
    getPermissions().then((res) => {
      if(res===undefined) return;
      if (res.data.success) {
        setLoading(false);
        setSpinning(false);
        let newData = res.data.data.filter((obj) => {
          obj.filtered = obj.active ? 1 : 0;
          return obj;
        });
        setPermissions(newData);
      }
    });
  };
  const onChangeStatus = (data) => {
    setLoading(true);
    let id = { id: data?.id };
    let action = data?.active === true ? false : true;
    PermissionRole(id, action).then((res) => {
      if(res===undefined) return;
      fetchPermissions();
    });
  };
  const onClickRefresh = () => {
    setSpinning(true);
    fetchPermissions();
  };
  const column = [
    {
      title: TitleValue("Id"),
      dataIndex: "id",
      sorter: (a, b) => a.id - b.id,
      defaultSortOrder: "ascend",
      align: "center",
      width: 20,
      render: (_, raw) => (
        <span
          style={{
            wordBreak: 'break-word',
  overflowWrap: 'break-word',
            fontSize: "15px",
            fontWeight: "300",
            display: "flex",
            width: "50%",
            justifyContent: "flex-end",
            textAlign: "right",
          }}
        >
          {raw.id}
        </span>
      ),
    },
    {
      title: TitleValue("Permissions"),
      dataIndex: "name",
      width: 100,
      sorter: (a, b) => a.name.localeCompare(b.name),
      // sorter: (a, b) => a.name - b.name,
      render: (_, row) => (
        <>
          <span
            style={{
              wordBreak: 'break-word',
  overflowWrap: 'break-word',
              fontSize: "15px",
              fontWeight: "300",
            }}
          >
            {row.name}
          </span>
        </>
      ),
    },
    {
      title: TitleValue("Status"),
      align: "center",
      dataIndex: "title",
      width: 20,
      // sorter: (a, b) => a.filtered - b.filtered,
      render: (_, row) => (
        <div
          style={{
            wordBreak: 'break-word',
  overflowWrap: 'break-word',
            fontSize: "15px",
            fontWeight: "300",
            textAlign: "center",
          }}
        >
          <Tag color={`${row.active ? "green" : "red"}`}>
            {row.active ? "Active" : "Inactive"}
          </Tag>
        </div>
      ),
    },
    {
      title: TitleValue(""),
      alignItem: "center",
      dataIndex: "title",
      width: 20,
      render: (_, row) => (
        <div
          style={{
            wordBreak: 'break-word',
  overflowWrap: 'break-word',
            fontSize: "15px",
            fontWeight: "300",
            textAlign: "center",
          }}
        >
          <Switch
            value={row.active}
            size="small"
            onClick={() => onChangeStatus(row)}
          />
        </div>
      ),
    },
  ];

  const onChangeTabSearch = (val) => {
    setValue(val);
  };
  useEffect(() => {
    fetchPermissions();
  }, []);

  return (
    <>
      <div
        className={styles.header}
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          padding: "15px",
          justifyContent: "space-between",
          marginTop: "15px",
        }}
      >
        <div
          style={{
            width: "57%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span>
            <SearchBar
              searchValue={value}
              handleSearch={(e) => onChangeTabSearch(e.target.value)}
              setSearchValue={setValue}
              // setCurrentPage={setCurrentPage}
            />
          </span>
          <span>
            <div
              style={{
                fontSize: "20px",
                display: "flex",
                alignItems: "center",
                fontWeight: "500",
              }}
            >
              List of Permissions&nbsp;
            </div>
          </span>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "40%",
            justifyContent: "end",
          }}
        >
          <span>
            <Tooltip
              color="#fff"
              title={() => {
                return (
                  <span style={{ color: "black", textTransform: "capitalize" }}>
                    Refresh
                  </span>
                );
              }}
            >
              <SyncOutlined
                colSpan={3}
                span={2}
                onClick={() => onClickRefresh()}
                spin={spinning}
                style={{ fontSize: "16px" }}
              />
            </Tooltip>
          </span>
        </div>
      </div>
      <div className="mt-2">
        <Spin spinning={isLoading}>
          <Table
            columns={column}
            rowClassName={(record, index) =>
              index % 2 === 0 ? "table-row-light" : "table-row-dark"
            }
            dataSource={filtering(permissions, value)}
            style={{ boxShadow: "7px 7px 20px lightgrey" }}
            showSorterTooltip={false}
            className="mb-5"
            pagination={false}
            scroll={{ y: 500 }}
          />
        </Spin>
      </div>
    </>
  );
}
